module.exports = __webpack_public_path__ + "static/media/requests.281592d5.svg";